import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ModalProvider } from './common/context/ModalProvider';
import { QueryClient, QueryClientProvider } from 'react-query';
import { AuthProvider } from './common/context/AuthProvider';
import { ScanProvider } from './common/context/ScanProvider';
import { GlobalProvider } from './common/context/GlobalProvider';
import { DialogProvider } from './common/hooks/useDialog';
import { DataProvider } from './common/hooks/useData';

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <BrowserRouter>
    <AuthProvider>
      <GlobalProvider>
        <QueryClientProvider client={queryClient}>
          <DataProvider>
            <ModalProvider>
              <ScanProvider>
                <DialogProvider>
                  <App />
                </DialogProvider>
              </ScanProvider>
            </ModalProvider>
          </DataProvider>
        </QueryClientProvider>
      </GlobalProvider>
    </AuthProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}
